
import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

const state = {
  list: [],
  omise: {
    public_key: '',
    secret_key: '',
    currency_id: '',
    currency_list: []
  },
  paypal: {
    client_id: '',
    secret: '',
    currency_id: '',
    currency_list: []
  },
  kpayment: {
    merchantId: '',
    publicKey: '',
    secretKey: ''
  },
  transfer: {
    type: 'default',
    manual_text: ''
  },
  check_currency: [],
  payment_lists: [],
  limit: 8,
  link_manual: {
    th: process.env.MANUAL_URL_TH + '#payment',
    en: process.env.MANUAL_URL_EN + '#payment',
    vi: process.env.MANUAL_URL_VI + '#payment'
  }
}

export default ({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/modules/payments/index.js